var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { classNames, renderIcon } from '../../../../utils';
import { Avatar } from '../../../avatar/avatar';
import Typography from '../../../typography/typography';
import { UserAvatar } from '../../../user-avatar/user-avatar';
import * as stackedListStyles from '../../attendance-stacked-list.styles';
import { AttendanceStatus } from '../../models/AttendanceItemStatus';
import * as styles from './attendance-list-item.styles';
export var AttendanceListItem = function (_a) {
    var _b;
    var item = _a.item, onBadgeClick = _a.onBadgeClick, className = _a.className, walkthrough = _a.walkthrough, type = _a.type;
    var _c = useState(item), attendanceItem = _c[0], setAttendanceItem = _c[1];
    useEffect(function () {
        var _a;
        item.status = (_a = item.status) !== null && _a !== void 0 ? _a : AttendanceStatus.Present;
        setAttendanceItem(item);
    }, [item]);
    var onBadgeClicked = function () {
        var currentItem = JSON.parse(JSON.stringify(attendanceItem));
        if (walkthrough) {
            if (currentItem.status &&
                currentItem.status === AttendanceStatus.Present) {
                currentItem.status = AttendanceStatus.Absent;
            }
            else if (currentItem.status === AttendanceStatus.Absent) {
                currentItem.status = AttendanceStatus.Present;
            }
            setAttendanceItem(currentItem);
            if (onBadgeClick) {
                onBadgeClick(currentItem);
            }
            return;
        }
        if (currentItem.status && currentItem.status !== AttendanceStatus.Absent) {
            currentItem.status = currentItem.status + 1;
        }
        else {
            currentItem.status = AttendanceStatus.Present;
        }
        setAttendanceItem(currentItem);
        if (onBadgeClick) {
            onBadgeClick(currentItem);
        }
    };
    var getBadgeIcon = function (status) {
        if (status) {
            switch (status) {
                case AttendanceStatus.Absent:
                    return 'XCircleIcon';
                case AttendanceStatus.Present:
                    return 'CheckCircleIcon';
                default:
                    return 'CheckCircleIcon';
            }
        }
        else {
            return 'CheckCircleIcon';
        }
    };
    return (_jsx("div", __assign({ className: classNames(className, attendanceItem === null || attendanceItem === void 0 ? void 0 : attendanceItem.className, styles.menulistItemContainer(attendanceItem.status, type)), onClick: function () {
            onBadgeClicked();
            attendanceItem.onActionClick && attendanceItem.onActionClick();
        } }, { children: _jsxs("div", __assign({ className: styles.contentWrapper }, { children: [_jsxs("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: [_jsx("div", { children: attendanceItem.profileDataUrl ? (_jsx(Avatar, { size: 'md', dataUrl: attendanceItem.profileDataUrl, displayBorder: true })) : (_jsx(UserAvatar, { size: 'md', avatarColor: item.avatarColor ||
                                    styles.avatarColor(attendanceItem.status, type), text: (_b = attendanceItem.profileText) !== null && _b !== void 0 ? _b : '', displayBorder: true })) }), _jsxs("div", __assign({ className: stackedListStyles.paragraphWrapper }, { children: [_jsx(Typography, { className: "truncate", type: "body", weight: "bold", color: "textMid", text: attendanceItem.title }), _jsx(Typography, { className: "truncate", type: "help", color: "textMid", text: attendanceItem.subTitle })] }))] })), _jsx("div", { children: renderIcon(getBadgeIcon(attendanceItem.status), styles.getColourByStatus(attendanceItem.status, type)) })] })) })));
};
export default AttendanceListItem;
//# sourceMappingURL=attendance-list-item.js.map